var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTabs',{attrs:{"tabs":_vm.steps,"activeTab":_vm.activeTab,"breadcrumbMode":true,"compact":_vm.compact},scopedSlots:_vm._u([{key:"tab",fn:function(ref){
var tabTitle = ref.tabTitle;
var tabStatus = ref.tabStatus;
return [_c('div',{staticClass:"text-sm",class:[_vm.titleClasses(tabStatus), _vm.compact ? 'pt-3 truncate' : ''],attrs:{"title":tabTitle}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.statusLabel(tabStatus)))]),_vm._v(" "+_vm._s(tabTitle)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }